export default "__VITE_ASSET__lPMtywRW__"